import axios from 'axios';
import qs from 'qs';

export const getSchools = () => axios.get('/api/v1/schools');

export const createSchool = (data: any) => axios.post('/api/v1/schools', data);

export const updateSchoolById = ({
  schoolId,
  data,
}: {
  schoolId: string;
  data: any;
}) => axios.put(`/api/v1/schools/${schoolId}`, data);

export const getSchoolById = (schoolId: string) =>
  axios.get(`/api/v1/schools/${schoolId}`);

export const getSchoolStudents = ({
  schoolId,
  params,
}: {
  schoolId: string;
  params: Record<string, any>;
}) => axios.get(`/api/v1/schools/${schoolId}/students?${qs.stringify(params)}`);

export const getSchoolAdmins = ({
  schoolId,
  params,
}: {
  schoolId: string;
  params: Record<string, any>;
}) => axios.get(`/api/v1/schools/${schoolId}/admins?${qs.stringify(params)}`);

export const getSchoolCourses = ({
  schoolId,
  params,
}: {
  schoolId: string;
  params: Record<string, any>;
}) => axios.get(`/api/v1/schools/${schoolId}/courses?${qs.stringify(params)}`);

export const getSchoolArcades = ({
  schoolId,
  params,
}: {
  schoolId: string;
  params: Record<string, any>;
}) => axios.get(`/api/v1/schools/${schoolId}/arcades?${qs.stringify(params)}`);

export const getSchoolTrainings = ({
  schoolId,
  params,
}: {
  schoolId: string;
  params: Record<string, any>;
}) =>
  axios.get(`/api/v1/schools/${schoolId}/trainings?${qs.stringify(params)}`);

export const getSchoolDailyChallenges = ({
  schoolId,
  params,
}: {
  schoolId: string;
  params: Record<string, any>;
}) =>
  axios.get(
    `/api/v1/schools/${schoolId}/daily-challenges?${qs.stringify(params)}`,
  );

export const getSchoolLessonRatings = ({
  schoolId,
  params,
}: {
  schoolId: string;
  params: Record<string, any>;
}) =>
  axios.get(`/api/v1/schools/${schoolId}/lesson-rates?${qs.stringify(params)}`);

export const getSchoolLessonReports = ({
  schoolId,
  params,
}: {
  schoolId: string;
  params: Record<string, any>;
}) =>
  axios.get(
    `/api/v1/schools/${schoolId}/lesson-reports?${qs.stringify(params)}`,
  );

export const getStudentsActivityReport = (schoolId: string) =>
  axios.post(
    `/api/v1/schools/${schoolId}/students/activity-report`,
    {},
    {
      responseType: 'blob',
    },
  );

export const getPublicCuratorReport = (
  token: string,
  params: {
    page: number;
    limit: number;
    search?: string;
    courseId?: string;
    accessFrom?: string;
    accessTo?: string;
    sortBy?: string;
    sortDirection?: 'asc' | 'desc';
  },
) =>
  axios.get(`/api/v1/schools/public/curator-report/${token}`, {
    params,
  });

export const getCuratorReport = (
  schoolId: string,
  params: {
    page: number;
    limit: number;
    search?: string;
    courseId?: string;
    accessFrom?: string;
    accessTo?: string;
    sortBy?: string;
    sortDirection?: 'asc' | 'desc';
  },
) =>
  axios.get(`/api/v1/schools/${schoolId}/curator-report`, {
    params,
  });

export const refreshCuratorReport = (
  schoolId: string,
  params: {
    page: number;
    limit: number;
    search?: string;
    courseId?: string;
    accessFrom?: string;
    accessTo?: string;
    sortBy?: string;
    sortDirection?: 'asc' | 'desc';
  },
) =>
  axios.post(`/api/v1/schools/${schoolId}/curator-report/refresh`, null, {
    params,
  });

export const refreshPublicCuratorReport = (
  token: string,
  params: {
    page: number;
    limit: number;
    search?: string;
    courseId?: string;
    accessFrom?: string;
    accessTo?: string;
    sortBy?: string;
    sortDirection?: 'asc' | 'desc';
  },
) =>
  axios.post(
    `/api/v1/schools/public/curator-report/${token}/refresh`,
    null,
    {
      params,
    },
  );

export const createCuratorReportShareLink = (
  schoolId: string,
  courseId?: string,
) =>
  axios.post(`/api/v1/schools/${schoolId}/curator-report/share-link`, null, {
    params: courseId ? { courseId } : undefined,
  });

export const getPublicCuratorStudentDetail = (
  token: string,
  studentId: string,
  courseId: string,
) =>
  axios.get(
    `/api/v1/schools/public/curator-report/${token}/students/${studentId}`,
    {
      params: { courseId },
    },
  );

export const getCuratorStudentDetail = (
  schoolId: string,
  studentId: string,
  courseId: string,
) =>
  axios.get(
    `/api/v1/schools/${schoolId}/curator-report/students/${studentId}`,
    {
      params: { courseId },
    },
  );
